import { DemoScriptMap } from './demo-script.types';
import { customerScript } from './customer.demo';
import { productScript } from './product.demo';
import { invoiceScript } from './invoice.demo';

export const DEMO_SCRIPTS: DemoScriptMap = {
  customer: customerScript,
  product: productScript,
  invoice: invoiceScript,
};
